import React, { FC, useMemo } from 'react';
import { DropdownControl, useScopedSelector } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { changeSubjectGroup } from '../../../../../NewMessagePage.actions';
import { NewMessagePageState } from '../../../../../../../interfaces/NewMessagePageState';
import { StyledText } from '../../../../../NewMessagePage.styles';
import useDefaultValue from '../../../../useDefaultValue';

export interface SubjectGroupsControlProps { disabled?: boolean }

const SubjectGroupsControl: FC<SubjectGroupsControlProps> = ({ disabled }) => {
  const { t } = useTranslation('NewMessagePage');
  const dispatch = useDispatch();
  const dispatchChangeSubjectGroup = () => dispatch(changeSubjectGroup());
  const subjectGroups = useScopedSelector((state: NewMessagePageState) => state.subjectGroups || []);
  const subjectGroupsOptions = useMemo(() => subjectGroups.map((g) => ({
    label: g.description,
    value: `${g.id}`,
  })), [subjectGroups]);

  const defaultValue = useDefaultValue('defaultsubjectsgroup', subjectGroupsOptions);

  return (
    <StyledText>
      <DropdownControl
        disabled={disabled}
        required={!disabled}
        name="subjectGroup"
        aria-label={t('object')}
        options={subjectGroupsOptions}
        onValueChange={() => dispatchChangeSubjectGroup()}
        defaultValue={defaultValue}
      />
    </StyledText>
  );
};

export default SubjectGroupsControl;
